
import { useMemo } from 'react';
import { useValidationYupDocumento, useValidationYupFone } from 'views/components/form-validations';
import * as Yup from 'yup';

export const useDialogIndicacaoRevendaValidation = () => {

    const { documentoYup } = useValidationYupDocumento(false)
    const telefoneYup = useValidationYupFone()

    const DialogIndicacaoRevendaValidationYup = useMemo(() => {
        return Yup.object().shape({
            cnpj: documentoYup("CNPJ"),
            nomeComercial: Yup.string().required("Nome comercial é obrigatório"),
            responsavel: Yup.string().required("Nome do responsável é obrigatório"),
            telefone: telefoneYup(),
        });
    }, [documentoYup, telefoneYup])

    return {
        DialogIndicacaoRevendaValidationYup,
    }
}